import BasePaper from '@/components/ui/BasePaper';
import BaseTitle from '@/components/ui/BaseTitle';
import { useTranslation } from 'react-i18next';

function ForbiddenPage() {
    const { t } = useTranslation('common');
    return (
        <>
            <BasePaper>
                <BaseTitle title={t('403 Forbidden')} />
            </BasePaper>
        </>
    );
}

export default ForbiddenPage;
